export const DEFAULT_ZOOM = 14
